// extracted by mini-css-extract-plugin
module.exports = {"ReasonsComponent":"ReasonsComponent_ReasonsComponent__a5l7D"};